// Hook słownika usług – GET /services?search=<q>&limit=20

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface IServiceDictionaryItem {
  id: number;
  name: string;
  taxPercent: number;
  costCalcMethod: number | null;
}

export interface IServicesDictionaryResponse {
  page: number;
  total_count: number;
  total_pages: number;
  items: IServiceDictionaryItem[];
}

const getServicesDictionary = (
  search: string,
  limit: number
): Promise<IServicesDictionaryResponse> =>
  axios.get('/services', {
    params: {
      ...(search.trim().length > 0 ? { search } : {}),
      limit
    }
  });

export const useGetServicesDictionary = (
  search = '',
  limit = 20,
  options?: UseQueryOptions<IServicesDictionaryResponse, IError>
) =>
  useQuery<IServicesDictionaryResponse, IError>(
    ['services-dictionary', search, limit],
    () => getServicesDictionary(search, limit),
    {
      ...options,
      keepPreviousData: true
    }
  );
